import React, { useState } from "react";
import { useFormik } from "formik";
import { connect } from "react-redux";
import { Link, Redirect } from "react-router-dom";
import * as Yup from "yup";
import { FormattedMessage, injectIntl } from "react-intl";
import * as auth from "../_redux/authRedux";
import { changePassword } from "../_redux/authCrud";
import { ShowToast, ToastType } from "../../../../_metronic/_helpers/ToastHelpers";

const initialValues = {
  oldPassword: "",
  newPassword: "",
  rePassword: "",
};

function ChangePassword(props) {
  const { intl } = props;
  const [isRequested, setIsRequested] = useState(false);
  const ChangePassSchema = Yup.object().shape({
    oldPassword: Yup.string()
      .required(
        intl.formatMessage({
          id: "AUTH.VALIDATION.REQUIRED_FIELD"
        })
      ),
    newPassword: Yup.string()
      .min(3, intl.formatMessage({
        id: "YUP.STRING.MIN3",
      }))
      .required(
        intl.formatMessage({
          id: "AUTH.VALIDATION.REQUIRED_FIELD",
        })
      ),
    rePassword: Yup.string()
      .oneOf([Yup.ref('newPassword'), null], intl.formatMessage({
        id: "AUTH.VALIDATION.CONFIRM_PASSWORD",
      }))
      .min(3, intl.formatMessage({
        id: "YUP.STRING.MIN3",
      }))
      .required(
        intl.formatMessage({
          id: "AUTH.VALIDATION.REQUIRED_FIELD",
        })

      ),

  });

  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }
    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }
    return "";
  };

  const formik = useFormik({
    initialValues,
    validationSchema: ChangePassSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      // const [oldPassword, newPassword] = values
      const user = JSON.parse(sessionStorage.authUser);
      // changePassword(user.username, oldPassword, newPassword)
      changePassword(user.username, values["oldPassword"], values["newPassword"])
        .then(() => {
          window.localStorage.clear()
          window.sessionStorage.clear()
          // window.location.replace("/auth/login");
          ShowToast("رمز عبور با موفقیت تغییر کرد. لطفا با رمز جدید وارد شوید.", ToastType.success);
          setIsRequested(true)
        })
        .catch((error) => {
          setIsRequested(false);
          setSubmitting(false);
          if (error.response) {
            setStatus(error.response.data.Message);
          }
          else {
            setStatus(
              intl.formatMessage(
                { id: "AUTH.VALIDATION.NOT_FOUND" },
              )
            );
          }

        });
    },
  });

  return (
    <>
      {isRequested && <Redirect to="/auth" />}
      {!isRequested && (
        <div className="login-form login-forgot" style={{ display: "block" }}>
          <div className="text-center mb-10 mb-lg-20">
            <h3 className="font-size-h1 text-dark"> <FormattedMessage id="NEWPASS.HEADER" /></h3>
            <div className="text-success font-weight-bold mt-3">
              <FormattedMessage id="NEWPASS.TEXT" />
            </div>
          </div>
          <form
            onSubmit={formik.handleSubmit}
            className="form fv-plugins-bootstrap fv-plugins-framework animated animate__animated animate__backInUp"
          >
            {formik.status && (
              <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
                <div className="alert-text font-weight-bold">
                  {formik.status}
                </div>
              </div>
            )}

            <div className="form-group fv-plugins-icon-container">
              <input
                placeholder={intl.formatMessage({
                  id: "AUTH.INPUT.PASSWORD",
                })}
                type="password"
                className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
                  "oldPassword"
                )}`}
                name="oldPassword"
                {...formik.getFieldProps("oldPassword")}
              />
              {formik.touched.oldPassword && formik.errors.oldPassword ? (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">{formik.errors.oldPassword}</div>
                </div>
              ) : null}
            </div>

            <div className="form-group fv-plugins-icon-container">
              <input
                placeholder={intl.formatMessage({
                  id: "AUTH.INPUT.NEWPASSWORD",
                })}
                type="password"
                className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
                  "newPassword"
                )}`}
                name="newPassword"
                {...formik.getFieldProps("newPassword")}
              />
              {formik.touched.newPassword && formik.errors.newPassword ? (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">{formik.errors.newPassword}</div>
                </div>
              ) : null}
            </div>

            <div className="form-group fv-plugins-icon-container">
              <input
                placeholder={intl.formatMessage({
                  id: "AUTH.INPUT.REPASSWORD",
                })}
                type="password"
                className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
                  "rePassword"
                )}`}
                name="rePassword"
                {...formik.getFieldProps("rePassword")}
              />
              {formik.touched.rePassword && formik.errors.rePassword ? (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">{formik.errors.rePassword}</div>
                </div>
              ) : null}
            </div>


            <div className="form-group d-flex flex-wrap flex-center">
              <button
                id="kt_login_forgot_submit"
                type="submit"
                className="btn btn-success font-weight-bold px-9 py-4 my-3 mx-4"
                disabled={formik.isSubmitting}
              >
                <FormattedMessage id="BUTTON.OK" />
              </button>
              <Link to="/auth">
                <button
                  type="button"
                  id="kt_login_forgot_cancel"
                  className="btn btn-light-success font-weight-bold px-9 py-4 my-3 mx-4"
                >
                  <FormattedMessage id="BUTTON.CANCEL" />
                </button>
              </Link>
            </div>
          </form>
        </div>
      )}
    </>
  );
}

export default injectIntl(connect(null, auth.actions)(ChangePassword));
